var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPortfolio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 54,
    viewBox: "0 0 53 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29_1811)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.932 50.7305H17.1471C11.1263 50.7305 6.78211 48.2042 4.75221 43.7186C3.87948 41.8301 3.43074 39.5864 3.43074 37.0141V17.2292C3.43074 13.8938 4.20631 11.083 5.65321 8.89056C2.12341 11.1572 0.160645 15.1446 0.160645 20.4587V40.2436C0.160645 42.8176 0.609378 45.0595 1.48211 46.9481C3.51201 51.4337 7.85624 53.96 13.877 53.96H33.6619C38.9195 53.96 42.8769 52.0396 45.1576 48.5823C42.9811 49.9815 40.2092 50.7288 36.932 50.7288V50.7305Z",
    fill: "#FF7324"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.98889 41.1235L6.94119 41.1712C6.30343 39.7773 5.90239 38.1961 5.73633 36.4489C5.90239 38.1731 6.34936 39.7313 6.98713 41.1235H6.98889Z",
    fill: "#FF7324"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1452 20.7467C25.2492 20.7467 27.7649 18.2309 27.7649 15.1269C27.7649 12.0229 25.2492 9.50714 22.1452 9.50714C19.0411 9.50714 16.5254 12.0229 16.5254 15.1269C16.5254 18.2309 19.0411 20.7467 22.1452 20.7467Z",
    fill: "#FF7324"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1209 0.961792H19.336C10.743 0.961792 5.61963 6.08512 5.61963 14.6782V34.4631C5.61963 37.0371 6.06836 39.279 6.9411 41.1676C8.971 45.6532 13.3152 48.1795 19.336 48.1795H39.1209C47.7158 48.1795 52.8391 43.0562 52.8391 34.4613V14.6764C52.8391 6.08512 47.7158 0.961792 39.1209 0.961792ZM48.9895 25.7517C47.1487 24.1705 44.1736 24.1705 42.331 25.7517L32.5101 34.1804C30.6692 35.7616 27.6941 35.7616 25.8515 34.1804L25.0494 33.5197C23.3729 32.0551 20.7052 31.9138 18.8166 33.1893L9.98683 39.1147C9.46743 37.7933 9.16003 36.258 9.16003 34.4631V14.6782C9.16003 8.01963 12.6775 4.50219 19.336 4.50219H39.1209C45.7795 4.50219 49.2969 8.01963 49.2969 14.6782V26.0114L48.9895 25.7517Z",
    fill: "#FF7324"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29_1811"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 53,
    fill: "white",
    transform: "translate(0 0.961792)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPortfolio);
export default __webpack_public_path__ + "static/media/IconPortfolio.b7ca09a7ad9d5e73cb50925d406c1a08.svg";
export { ForwardRef as ReactComponent };